import config from '../../config';

import { invokeApig } from '../../utils/awsLib';

import * as endpoints from '../../endpoints';

import { authenticateCurrentUser } from '../authenticate/actions';

import * as types from './types';
import * as leadStatus from './status';

// Show user's leads
function getUserLeadRequest() {
  return {
    type: types.USERLEAD_REQUEST,
  };
}

function getUserLeadSuccess(status, userLeads) {
  return {
    type: types.USERLEAD_SUCCESS,
    payload: {
      status,
      userLeads,
    },
  };
}

function getUserLeadFail(status, message) {
  return {
    type: types.USERLEAD_FAILURE,
    payload: {
      status,
      statusText: message,
    },
  };
}

export function getUserLead(body) {
  return async (dispatch) => {
    dispatch(getUserLeadRequest());
    const path = endpoints.USERLEADS;
    let result;
    try {
      const token = await dispatch(authenticateCurrentUser());
      result = await invokeApig({
        path,
        method: 'POST',
        body,
        gateway: config.apiGateway,
      }, token);
    } catch (e) {
      console.log('userlead', e.message);
      const errStatus = leadStatus.USERLEAD_STATUS_ERROR;
      dispatch(getUserLeadFail(errStatus, e.message));
      return errStatus;
    }
    dispatch(getUserLeadSuccess(leadStatus.USERLEAD_STATUS_OK, result));
    return leadStatus.USERLEAD_STATUS_OK;
  };
}

export function resetUserLead() {
  return {
    type: types.USERLEAD_RESET,
  };
}

//Show all leads
function getLeadsRequest() {
  return {
    type: types.LEADS_REQUEST,
  };
}

function getLeadsSuccess(status, leads) {
  return {
    type: types.LEADS_SUCCESS,
    payload: {
      status,
      leads,
    },
  };
}

function getLeadsFail(status, message) {
  return {
    type: types.LEADS_FAILURE,
    payload: {
      status,
      statusText: message,
    },
  };
}

export function getLeads(body) {
  return async (dispatch) => {
    dispatch(getLeadsRequest());
    const path = endpoints.LEADS;
    let result;
    try {
      const token = await dispatch(authenticateCurrentUser());
      result = await invokeApig({
        path,
        method: 'POST',
        body,
        gateway: config.apiGateway,
      }, token);
    } catch (e) {
      console.log('leads', e.message);
      const errStatus = leadStatus.LEADS_STATUS_ERROR;
      dispatch(getLeadsFail(errStatus, e.message));
      return errStatus;
    }
    dispatch(getLeadsSuccess(leadStatus.LEADS_STATUS_OK, result));
    return leadStatus.LEADS_STATUS_OK;
  };
}

export function resetLeads() {
  return {
    type: types.LEADS_RESET,
  };
}



// WEBPACK FOOTER //
// ./src/redux/leads/actions.js